export class User {
  name: string;
  mail: string;
  role: string;
  action: string;
}
